export const devices = {
    Ios: 'Ios',
    Android: 'Android'
};